// import access from "@/mixins/access";
import queryform from "@/mixins/queryform";

export default {
  mixins: [queryform],
};
